import React, { memo } from 'react';
import ServerTypeSelector from '../ServerTypeSelector';
import { SnappyAnimation } from '@/pages/Loader/SnappyAnimation/SnappyAnimation';
import * as Styles from './EmptyState.styles';
import useLocale from '@/hooks/useLocale';

const EmptyState = memo(({
  onSelectVPS,
  onSelectDedicated,
}) => {
  const { productDetails: productDetailsLocale } = useLocale();
  const { advancedHosting: advancedHostingLocale } = productDetailsLocale || {};

  return (
    <Styles.Container data-testid="advanced-hosting-empty-state">
      <Styles.Content>
        <Styles.Header>
          <Styles.IconWrapper>
            <SnappyAnimation
              noAnimation
            />
          </Styles.IconWrapper>
          <Styles.Text>
            <Styles.Title data-testid="advanced-hosting-empty-state-title">{advancedHostingLocale?.emptyState?.title}</Styles.Title>
            <Styles.Subtitle data-testid="advanced-hosting-empty-state-subtitle">{advancedHostingLocale?.emptyState?.subtitle}</Styles.Subtitle>
          </Styles.Text>
        </Styles.Header>

        <ServerTypeSelector
          locale={advancedHostingLocale.emptyState.selector}
          onSelectVPS={onSelectVPS}
          onSelectDedicated={onSelectDedicated}
        />
      </Styles.Content>
    </Styles.Container>
  );
});

EmptyState.displayName = 'EmptyState';
export default EmptyState;
